export default __webpack_public_path__ + "static/media/mail-red.068d95e4.svg";